import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-performance-marketing',
  imports: [CommonModule, RouterLink],
  templateUrl: './performance-marketing.html',
  styleUrl: './performance-marketing.css'
})
export class PerformanceMarketing {
  services = [
    {
      title: 'Paid Ads Management',
      description: 'Maximize ROI with data-driven Google, Facebook, LinkedIn, and programmatic advertising campaigns.',
      icon: 'ads',
      link: '/performance-marketing/paid-ads',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop'
    },
    {
      title: 'Analytics & Tracking',
      description: 'Comprehensive analytics setup with GA4, GTM, and custom dashboards for actionable insights.',
      icon: 'analytics',
      link: '/performance-marketing/analytics',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop'
    },
    {
      title: 'Conversion Rate Optimization',
      description: 'A/B testing, landing page optimization, and UX improvements to boost conversions.',
      icon: 'cro',
      link: '/performance-marketing/cro',
      image: 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=400&h=300&fit=crop'
    },
    {
      title: 'SEO & Content Strategy',
      description: 'Technical SEO, content marketing, and link building for sustainable organic growth.',
      icon: 'seo',
      link: '/performance-marketing/seo',
      image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=400&h=300&fit=crop'
    },
    {
      title: 'Marketing Automation',
      description: 'Streamline workflows with HubSpot, Marketo, and custom automation solutions.',
      icon: 'automation',
      link: '/performance-marketing/automation',
      image: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=400&h=300&fit=crop'
    },
    {
      title: 'Lead Generation & Management',
      description: 'Full-funnel lead generation strategies with CRM integration and nurturing workflows.',
      icon: 'leads',
      link: '/performance-marketing/lead-generation',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop'
    },
    {
      title: 'Social Media Content Management',
      description: 'Strategic content creation, scheduling, and community management across platforms.',
      icon: 'social',
      link: '/performance-marketing/social-media',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=300&fit=crop'
    }
  ];

  caseStudies = [
    {
      client: 'TechStart SaaS',
      industry: 'B2B Software',
      challenge: 'Low conversion rates and high customer acquisition costs were limiting growth.',
      solution: 'Implemented comprehensive paid ads strategy with advanced audience targeting and landing page optimization.',
      results: ['340% increase in qualified leads', '52% reduction in CAC', '215% improvement in ROAS'],
      image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=400&fit=crop'
    },
    {
      client: 'HealthPlus Clinic',
      industry: 'Healthcare',
      challenge: 'Needed to increase patient bookings while maintaining compliance with healthcare advertising regulations.',
      solution: 'Developed compliant multi-channel campaign with local SEO, Google Ads, and social media marketing.',
      results: ['180% increase in appointment bookings', '45% growth in organic traffic', '4.8x ROI on ad spend'],
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop'
    },
    {
      client: 'EcoStore Retail',
      industry: 'E-commerce',
      challenge: 'Seasonal sales fluctuations and competition from larger retailers.',
      solution: 'Built year-round marketing automation with personalized email campaigns and retargeting.',
      results: ['125% increase in repeat customers', '38% higher average order value', '290% email revenue growth'],
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop'
    }
  ];

  testimonials = [
    {
      quote: 'HoneyKode transformed our digital marketing. Their data-driven approach delivered results we never thought possible.',
      author: 'Sarah Johnson',
      role: 'CMO',
      company: 'TechStart SaaS',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
    },
    {
      quote: 'The team understood our healthcare compliance needs perfectly. Patient bookings increased dramatically while staying fully compliant.',
      author: 'Dr. Michael Chen',
      role: 'Director',
      company: 'HealthPlus Clinic',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
    },
    {
      quote: 'Our e-commerce sales have never been better. The automation workflows they built save us hours every week.',
      author: 'Emma Williams',
      role: 'Founder',
      company: 'EcoStore Retail',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
    }
  ];

  stats = [
    { value: '500+', label: 'Campaigns Launched' },
    { value: '$50M+', label: 'Ad Spend Managed' },
    { value: '340%', label: 'Average ROI Increase' },
    { value: '98%', label: 'Client Retention' }
  ];
}
